import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '=',
        form: '=',
        isReadOnly: '<'
    },
    template: `
        <div class="block01">
            <div class="heading01 heading01b">
                <h3>{{ 'planningGroup.Targets' | translate }}</h3>
                <a class="btn add" ng-if="!vm.isReadOnly" ng-click="vm.addTarget()">{{ 'planningGroup.Add target' | translate }}</a>
            </div>
            <div class="tablewrapper">
                <list-empty list="vm.defaultTargets" show-add-message="true"></list-empty>
                <table ng-if="vm.defaultTargets.length"
                    class="data01"
                    dt-options="vm.DATATABLES">
                    <thead>
                        <tr role="row">
                            <th>{{ 'planningGroup.Department' | translate }}</th>
                            <th>{{ 'planningGroup.Role' | translate }}</th>
                            <th>{{ 'planningGroup.Level' | translate }}</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="target in vm.defaultTargets" role="row" class="odd">
                            <td>
                                <span ng-if="target.courseTarget.departmentName">{{ target.courseTarget.departmentName }}</span>
                                <span ng-if="!target.courseTarget.departmentName">{{ 'planningGroup.All departments' | translate }}</span>
                            </td>
                            <td>
                                <span ng-if="target.courseTarget.roleName">{{ target.courseTarget.roleName }}</span>
                                <span ng-if="!target.courseTarget.roleName">{{ 'planningGroup.All roles' | translate }}</span>
                            </td>
                            <td>
                                <span ng-if="target.courseTarget.levelName">{{ target.courseTarget.levelName }}</span>
                                <span ng-if="!target.courseTarget.levelName">{{ 'planningGroup.All levels' | translate }}</span>
                            </td>
                            <td class="actions">
                                <a class="btn delete"
                                    ng-if="!vm.isReadOnly"
                                    ng-click="vm.removeTarget(target.id)"
                                >{{ 'general.Remove' | translate }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()" class="block01 mt20">
            <div class="heading01 heading01b">
                <h3>{{ 'planningGroup.Exceptions' | translate }}</h3>
                <a class="btn add" ng-if="!vm.isReadOnly" ng-click="vm.addExceptionTarget()">{{ 'planningGroup.Add rule' | translate }}</a>
            </div>
            <div class="tablewrapper">
                <list-empty list="vm.exceptionTargets" show-add-message="true"></list-empty>
                <table class="data01 col-4" dt-options="vm.DATATABLES" ng-if="vm.exceptionTargets.length">
                    <thead>
                        <tr>
                            <th>{{ 'employee.First Name' | translate }}</th>
                            <th>{{ 'employee.Last Name' | translate }}</th>
                            <th>{{ 'employee.Position' | translate }}</th>
                            <th>{{ 'courses.Need' | translate }}</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="target in vm.exceptionTargets">
                            <td>{{ target.courseTarget.employee.firstName }}</td>
                            <td>{{ target.courseTarget.employee.lastName }}</td>
                            <td>
                                <p ng-repeat="employeeDrl in target.courseTarget.employee.drlsWithValue">
                                    {{ employeeDrl.departmentName }}, {{ employeeDrl.roleName }}, {{ employeeDrl.levelName }}
                                </p>
                            </td>
                            <td>{{ vm.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.LABELS[target.courseTarget.type] }}</td>
                            <td class="actions">
                                <a class="btn delete"
                                    ng-if="!vm.isReadOnly"
                                    ng-click="vm.removeTarget(target.id, true)"
                                >{{ 'general.Remove' | translate }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, toastr, lodash, CourseResource, ClassifierResource,
                 AutomatedPlanningGroupResource, ModalService, TokenService,
                 DATATABLES, CLASSIFIER_ENUM, COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.CourseResource = CourseResource;
        this.ClassifierResource = ClassifierResource;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM = COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM;
    }

    $onInit () {
        this.loadDefaultTargets();
        this.loadExceptionTargets();

        this.CourseResource.get({ id: this.form.model.courseId, expand: 'courseTargetsWithValue.employee.drlsWithValue' })
            .$promise
            .then((course) => {
                this.loadCourseDefaultTargets(course);
                this.loadCourseExceptionTargets(course);
            });
    }

    reloadPlanningGroup () {
        this.AutomatedPlanningGroupResource.get({
            id: this.planningGroup.id,
            expand: 'planningGroupUsers,course,planningGroupTargetsWithValue.user.drlsWithValue,planningGroupTargetsWithValue.courseTarget.employee.drlsWithValue,' +
                'targetRulesets.conditions.course.activeI18n,targetRulesets.conditions'
        })
            .$promise
            .then((reloadedPlanningGroup) => {
                this.planningGroup.planningGroupTargetsWithValue = reloadedPlanningGroup.planningGroupTargetsWithValue;
                this.form.model.targets = reloadedPlanningGroup.planningGroupTargetsWithValue;
                this.form.model.targetRulesets = reloadedPlanningGroup.targetRulesets;
                this.loadDefaultTargets();
                this.loadExceptionTargets();
            });
    }

    loadDefaultTargets () {
        if (this.form.model.targets) {
            this.defaultTargets = this.form.model.targets.filter((target) => !target.courseTarget.employeeId);
        }
    }

    loadExceptionTargets () {
        if (this.form.model.targets) {
            this.exceptionTargets = this.form.model.targets.filter((target) => target.courseTarget.employeeId);
        }
    }

    loadCourseDefaultTargets (course) {
        this.courseDefaultTargets = course.courseTargetsWithValue.filter((courseTarget) => {
            return !courseTarget.employeeId && courseTarget.type === this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.KEYS.COMPULSORY;
        });
    }

    loadCourseExceptionTargets (course) {
        this.courseExceptionTargets = course.courseTargetsWithValue.filter((courseTarget) => {
            return courseTarget.employeeId && courseTarget.type === this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.KEYS.COMPULSORY;
        });
    }

    addTarget () {
        const { planningGroup, courseDefaultTargets } = this;

        return this.ModalService.open({
            size: 'large',
            template: `
                <modals-planning-group-target-add
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    planning-group="vm.planningGroup"
                    course-targets="vm.courseDefaultTargets"
                />
                `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.planningGroup = planningGroup;
                this.courseDefaultTargets = courseDefaultTargets;
            }
        }).then(() => this.reloadPlanningGroup());
    }

    addExceptionTarget () {
        const { departments, roles, levels, planningGroup, exceptionTargets, courseExceptionTargets } = this;

        return this.ModalService.open({
            size: 'large',
            template: `
                <modals-planning-group-target-exception-add
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    planning-group="vm.planningGroup"
                    exception-targets="vm.exceptionTargets"
                    course-exception-targets="vm.courseExceptionTargets"
                />
                `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.departments = departments;
                this.roles = roles;
                this.levels = levels;
                this.planningGroup = planningGroup;
                this.exceptionTargets = exceptionTargets;
                this.courseExceptionTargets = courseExceptionTargets;
            }
        }).then(() => this.reloadPlanningGroup());
    }

    removeTarget (targetId, isException = false) {
        let message = this.$translate.instant('planningGroup.confirm_before_deleting_target');
        if (isException) {
            message = this.$translate.instant('planningGroup.confirm_before_deleting_exception_target');
        }
        return this.ModalService.delete(message)
            .then(() => {
                this.originalTargets = angular.copy(this.form.model.targets);
                const remainingTargets = this.lodash.filter(this.form.model.targets, (target) => target.id !== targetId);
                const targets = remainingTargets.map(target => ({
                    id: target.id || null,
                    courseTargetId: target.courseTargetId
                }));

                this.AutomatedPlanningGroupResource.setTargets(
                    { id: this.planningGroup.id },
                    { targets }
                ).$promise
                    .then(() => {
                        this.toastr.success(this.$translate.instant('course.Target deleted'));
                        this.reloadPlanningGroup();
                    })
                    .catch(() => {
                        this.form.model.targets = this.originalTargets;
                    });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/steps/targets/list/index.js